import React from "react";

const Skills = ({ data }) => {
  if (data) {
    // var skillmessage = data.skillmessage;
    var education = data.education.map(function (education) {
      return (
        <div key={education.school}>
          <h3>{education.school}</h3>
          <p>
            {education.degree} <span>&bull;</span>
            <em className="date">{`  ${education.graduated}`}</em>
            {education.description ? <p>{education.description}</p> : null}
          </p>
        </div>
      );
    });
    var skills = data.skills.map(function (skills) {
      // var className = "bar-expand " + skills.name.toLowerCase();
      return (
        <li
          key={skills.name}
          style={{ display: "inline-block", margin: "5px" }}
        >
          <span className="skill-badge">{skills.name}</span>
        </li>
      );
    });
    var tools = data.tools.map((tool) => {
      // var className = "bar-expand " + skills.name.toLowerCase();
      return (
        <li key={tool.name} style={{ display: "inline-block", margin: "5px" }}>
          <span className="skill-badge">{tool.name}</span>
        </li>
      );
    });
  }

  return (
    <section id="resume">
      <div className="row education">
        <div className="three columns header-col">
          <h1>
            <span>Education</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <div className="row item">
            <div className="twelve columns">{education}</div>
          </div>
        </div>
      </div>

      <div className="row skill education">
        <div className="three columns header-col">
          <h1>
            <span>Skills</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          {/* <div className="bars">
            <ul className="skills">{skills}</ul>
          </div> */}
          <div className="skill-badge-container">{skills}</div>
        </div>
      </div>
      <div className="row skill">
        <div className="three columns header-col">
          <h1>
            <span>Tools</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <div className="skill-badge-container">{tools}</div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
